module.exports = __webpack_public_path__ + "static/media/1-1.35b3f7a3.svg";